import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-toggle"
export default class PasswordToggleController extends Controller {
  static targets = ["input"]

  toggle(event) {
    const eye = event.currentTarget

    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      eye.classList.add("active")
    } else {
      this.inputTarget.type = "password"
      eye.classList.remove("active")
    }
  }
}
